<template>
    <div>
        <b-container fluid class="mt--7">
            <b-overlay v-if="isList" :show="!loaded" rounded="sm">
                <list-items
                    title="Assets Management"
                    :items="assets"
                    ref="table"
                >
                    <b-button variant="primary" :to="`${$route.path}/0`" block
                        >Add Asset</b-button
                    >
                </list-items>
            </b-overlay>
            <view-item :id="id" v-else></view-item>
        </b-container>
    </div>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'

export default {
    name: 'Asset',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, showItemHelper],
    data: () => {
        return {
            loaded: false,
        }
    },

    computed: {
        assets() {
            const assets = this.$store.state.assets.assets
            console.log('assets', assets)
            return assets
        },
        newRoute() {
            return this.$route.path + '/' + this.id + '/usage'
        },
    },
    watch: {
        assets: {
            handler: function () {
                this.loaded = true
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('locations/fetchWarehouses')
        //this.$store.dispatch('customers/fetch', { query: '', page: 1 })
    },

    methods: {},
}
</script>
<style></style>